module.exports = __webpack_public_path__ + "img/method-paids.62a39957.svg";